import { useEffect, useState } from "react";
import { getDoctorsFromApi } from "../services/doctorsService";

let doctorsCache = null;
let doctorsPromise = null;

const loadDoctorsOnce = async () => {
  if (doctorsCache !== null) return doctorsCache;
  if (doctorsPromise) return doctorsPromise;

  doctorsPromise = getDoctorsFromApi()
    .then((result) => {
      doctorsCache = result;
      return result;
    })
    .catch((error) => {
      doctorsPromise = null;
      throw error;
    });

  return doctorsPromise;
};

export const useDoctorsDirectory = () => {
  const [doctors, setDoctors] = useState(doctorsCache ?? []);
  const [loading, setLoading] = useState(doctorsCache === null);

  useEffect(() => {
    if (doctorsCache !== null) {
      setDoctors(doctorsCache);
      setLoading(false);
      return;
    }

    setLoading(true);

    loadDoctorsOnce()
      .then((result) => {
        setDoctors(result);
        setLoading(false);
      })
      .catch(() => {
        setDoctors([]);
        setLoading(false);
      });
    return;
  }, []);

  return { doctors, loading };
};
